<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="fullweeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >mileage report</small
                >
              </legend>
              <form @submit.prevent="loadfullmileages()">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control full_from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control full_end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Days</label>
                      <input
                        type="number"
                        class="form-control day_out"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingFullmileages"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingFullmileagesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage mileage</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-success btn-roundec"
                data-toggle="modal"
                data-target="#fullweeklyexpensesModal"
              >
                <i class="fa fa-file-pdf-o"></i> General mileage
              </button>
              <p></p>
              <div></div>
              <div>
                <div class="mileagesLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading mileages...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="Mileages"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'Action'">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm btn-rounded invoice_id"
                        @click="viewMileage(props.row.id)"
                      >
                        <i class="fa fa-print"></i>
                        Print
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Invoice number",
          field: "invoice_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter invoice reference",
          },
        },
        {
          label: "Mileage date.",
          field: "mileage_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        },
        {
          label: "Grand total",
          field: "grand_total",
          type: "text",
        },
        {
          label: "Action",
          field: "Action",
          width: "100px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadMileages();
  },
  computed: {
    ...mapGetters(["Mileages"]),
  },
  methods: {
    ...mapActions(["loadMileages", "viewMileage", "loadfullmileages"]),
  },
};
</script>
<style scoped>
.creatingFullmileagesLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/mileages/managemileages.vue